import * as CookieConsent from "vanilla-cookieconsent";
class CookieBanner {
    init() {
        // Enable dark mode
        document.documentElement.classList.add("cc--darkmode");

        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: "box",
                    position: "bottom left",
                    equalWeightButtons: true,
                    flipButtons: false,
                },
                preferencesModal: {
                    layout: "box",
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false,
                },
            },
            categories: {
                necessary: {
                    readOnly: true,
                },
                analytics: {},
            },
            language: {
                default: "nl",
                translations: {
                    en: {
                        consentModal: {
                            title: "Hello! Before you continue:",
                            description:
                                "We use cookies to improve your experience on our website, collect statistics and show personalised content. You can choose which cookies you allow.",
                            closeIconLabel: "",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            showPreferencesBtn: "Manage preferences",
                            footer: "",
                        },
                        preferencesModal: {
                            title: "Cookie preferences",
                            closeIconLabel: "Close window",
                            acceptAllBtn: "Accept all",
                            acceptNecessaryBtn: "Reject all",
                            savePreferencesBtn: "Save preferences",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookie usage",
                                    description:
                                        "We use cookies to improve the functionality of our website and provide a better user experience.",
                                },
                                {
                                    title: 'Necessary cookies <span class="pm__badge">Always enabled</span>',
                                    description:
                                        "These cookies ensure that the website functions properly. This includes features such as secure login, remembering your preferences and loading pages smoothly. Without these cookies, the website cannot function correctly.",
                                    linkedCategory: "necessary",
                                },
                                {
                                    title: "Analytics cookies",
                                    description:
                                        "These cookies help us understand how visitors use our website. This allows us to see what works well and what can be improved. The collected data is completely anonymous and helps us continuously improve the website.",
                                    linkedCategory: "analytics",
                                },
                            ],
                        },
                    },
                    nl: {
                        consentModal: {
                            title: "Hallo! Voordat je verder gaat:",
                            description:
                                "We gebruiken cookies om je ervaring op onze website te verbeteren, om statistieken bij te houden en om gepersonaliseerde inhoud te tonen. Je kunt zelf kiezen welke cookies je toestaat.",
                            closeIconLabel: "",
                            acceptAllBtn: "Alles acceptereren",
                            acceptNecessaryBtn: "Alles weigeren",
                            showPreferencesBtn: "Voorkeuren beheren",
                            footer: "",
                        },
                        preferencesModal: {
                            title: "Voorkeurencentrum",
                            closeIconLabel: "Sluit venster",
                            acceptAllBtn: "Alles accepteren",
                            acceptNecessaryBtn: "Alles weigeren",
                            savePreferencesBtn: "Voorkeuren opslaan",
                            serviceCounterLabel: "Service|Services",
                            sections: [
                                {
                                    title: "Cookiegebruik",
                                    description:
                                        "Wij houden cookies bij voor een betere werking en ervaring op onze website.",
                                },
                                {
                                    title: 'Vereiste cookies <span class="pm__badge">Altijd aan</span>',
                                    description:
                                        "Deze cookies zorgen dat de website goed werkt. Denk aan dingen als veilig inloggen, je voorkeuren onthouden en pagina’s soepel laten laden. Zonder deze cookies kan de site niet goed functioneren.",
                                    linkedCategory: "necessary",
                                },
                                {
                                    title: "Analytics Cookies",
                                    description:
                                        "Met deze cookies kunnen we zien hoe bezoekers onze website gebruiken. Zo leren we wat goed werkt en wat beter kan: volledig anoniem natuurlijk. Zo kunnen we de site steeds een beetje verbeteren.",
                                    linkedCategory: "analytics",
                                },
                            ],
                        },
                    },
                },
            },
        });
    }
}

export default CookieBanner;
